// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"e14d5050","594":"defce9b1","837":"355837cd"}[chunkId] + ".chunk.css";
};